module.exports = __webpack_public_path__ + "static/media/chair-model.1af206cc.png";